import axios from "axios";
import { authHeaderFile, authHeaderJson } from "../auth-header.service";
import moment from "moment";
import { isNullUndefinedOrEmpty } from "../../common/Helpers";

const getGAPById = (gapAnalyzeId) => {
    return axios.get(`/api/SkGAP/gapanalyze/${gapAnalyzeId}`, { headers: authHeaderJson() })
};

const getGapAnalizeByElementId = (elementId) => {
    return axios.get(`/api/SkGAP/gapanalyze/${elementId}`, { headers: authHeaderJson() })
};

const getHomeGapStadistic = (calendarSelectorId, periodId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkHome/boardHome/gap/${calendarSelectorId}/${periodId}`, { headers: authHeaderJson() })    
};

const getElementsByGAPId = (gapAnalyzeId) => {
    return axios.get(`/api/SkGAP/gapanalyzeelements/${gapAnalyzeId}/list`, { headers: authHeaderJson() } );
};

const getListGapAnalyzeDataseriesIds = (gapAnalyzeId, elementId, gapRevisionId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkGAP/gapanalyzedataseriesids/${gapAnalyzeId}/${isNullUndefinedOrEmpty(elementId) ? 0 : elementId}/${isNullUndefinedOrEmpty(gapRevisionId) ? 0 : gapRevisionId}/list?`, { headers: authHeaderJson() } );
};

const getFishboneTemplateList = () => {
    return axios.get(`/api/SkGAP/fishboneconcepts/list`, { headers: authHeaderJson() } );
};

const getGapRevisionsList = (gapAnalyzeId) => {
    return axios.get(`/api/SkGAP/gaprevisions/${gapAnalyzeId}/list`, { headers: authHeaderJson() } );
};

const getGapRevisionPossibleGaps = (gapAnalyzeId, elementId, gapRevisionId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkGAP/gaprevisionpossiblegaps/${gapAnalyzeId}/${isNullUndefinedOrEmpty(elementId) ? 0 : elementId}/${isNullUndefinedOrEmpty(gapRevisionId) ? 0 : gapRevisionId}/list`, { headers: authHeaderJson() } );
};

const getGapRevisionPossibleActions = (gapAnalyzeId, elementId, gapRevisionId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkGAP/gaprevisionpossibleactions/${gapAnalyzeId}/${isNullUndefinedOrEmpty(elementId) ? 0 : elementId}/${isNullUndefinedOrEmpty(gapRevisionId) ? 0 : gapRevisionId}/list`, { headers: authHeaderJson() } );
};





const addGapRevision = (objRevision) => {
    return axios.post(`/api/SkGAP/gaprevisionitem`, objRevision, { headers: authHeaderJson() });
};


const updateGapRevisionStatus = (gapRevisionId, gapRevisionStatusId) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/SkGAP/gaprevisionstatus/${gapRevisionId}/${gapRevisionStatusId}`, { headers: authHeaderJson() } )
};

/*const getGapRevisionDatareieList = (gapAnalyzeId, elementId, gapRevisionId) => {
    let qs_gapAnalyzeId = gapAnalyzeId !== null ? `?gap_analyze_id=${gapAnalyzeId}` : '';
    let qs_elementId = elementId !== null ? `&element_id=${elementId}` : '';
    let qs_gapRevisionId = gapRevisionId !== null ? `&gap_revision_id=${gapRevisionId}` : '';

    return axios.get(`/api/SkGAP/gapanalyzedataseries/${gapAnalyzeId}/list${qs_gapAnalyzeId}${qs_elementId}${qs_gapRevisionId}`, { headers: authHeaderJson() } );
};*/

const getGapRevisionDatareieList = (gapAnalyzeId, elementId, gapRevisionId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkGAP/gapanalyzedataseries/${gapAnalyzeId}/${isNullUndefinedOrEmpty(elementId) ? 0 : elementId}/list`, { headers: authHeaderJson() } );
};

const getListGaps = (gapAnalyzeId, elementId, gapRevisionId, gapRevisionDataserieId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkGAP/gaps/${gapAnalyzeId}/${isNullUndefinedOrEmpty(elementId) ? 0 : elementId}/${isNullUndefinedOrEmpty(gapRevisionId) ? 0 : gapRevisionId}/${isNullUndefinedOrEmpty(gapRevisionDataserieId) ? 0 : gapRevisionDataserieId}/list`, { headers: authHeaderJson() } );
};

const saveCausesByGapId = (gapAnalyzeId, elementId, dataserieId, gapRevisionId, gapDataserieValueId, objCauseList) => {
    //[##PATH ROUTE##]
    return axios.put(`/api/SkGAP/gapcausesadd/${gapAnalyzeId}/${elementId}/${dataserieId}/${gapDataserieValueId}/list`, objCauseList, { headers: authHeaderJson() });
};

const saveActionsByElementId = (gapAnalyzeId, objActionList, fromGapSection) => {
    //[##PATH ROUTE##]
    return axios.put(`/api/SkGAP/gapactionsadd/${gapAnalyzeId}/list?from_gap_section=${fromGapSection}`, objActionList, { headers: authHeaderJson() });
};

const updateActionState = (gapAnalyzeId, gapRevisionId, objAction) => {
    //[##DEPRECATED##]
    return axios.put(`/api/SkGAP/gapactionupdatestate/${gapAnalyzeId}?gap_analyze_id=${gapAnalyzeId}&gap_revision_id=${gapRevisionId}`, objAction, { headers: authHeaderJson() });
};

const getGapAnalyzeMyActions = (gapAnalyzeId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkGAP/gapanalyzemyactions/${gapAnalyzeId}/list`, { headers: authHeaderJson() } );
};

const getListGapCausesBoard = (gapAnalyzeId, elementId, dataserieValueId, gapRevisionId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkGAP/getgapcausesboard/${gapAnalyzeId}/${elementId}/${isNullUndefinedOrEmpty(gapRevisionId) ? 0 : gapRevisionId}/${isNullUndefinedOrEmpty(dataserieValueId) ? 0 : dataserieValueId}/list`, { headers: authHeaderJson() } );
};

const getGapFull = (gapAnalyzeId, elementId, gapAnalyzeDataserieId, calendarSelectorId, periodStartDate, periodEndsDate) => {
    //[##PATH ROUTE##]
    let qs_periodStartDate = periodStartDate !== null ? `period_start_date=${moment(periodStartDate).format('MM/DD/YYYY')}` : '';
    let qs_periodEndsDate = periodEndsDate !== null ? `period_ends_date=${moment(periodEndsDate).format('MM/DD/YYYY')}` : '';

    let url = `/api/SkGAP/gapfull/${gapAnalyzeId}/${elementId}/${isNullUndefinedOrEmpty(gapAnalyzeDataserieId) ? 0 : gapAnalyzeDataserieId}/${calendarSelectorId}/list`
 
    if(qs_periodStartDate !== '' )
    {
        url = url + '?' + qs_periodStartDate
    }
    if(qs_periodEndsDate !== '')
    {
        if(qs_periodStartDate != '' )
        {
            url = url + '&' + qs_periodEndsDate
        }
        else
        {
            url = url + '?' + qs_periodEndsDate		
        }
    }

    return axios.get(url, { headers: authHeaderJson() } );
};

const createGapAnalyzeProcess = (elemenentId) => { 
    //[##PATH ROUTE##]
    return axios({ method: 'post', url: `/api/SkGAP/gapanalyzeprocess/${elemenentId}`, headers: authHeaderJson() })
};

const addFishboneToGAPBusinessElement = (gapAnalyzeId, gapAnalyzeElementId, fishboneConceptId) => {
    //[##PATH ROUTE##]
    return axios({ method: 'post', url: `/api/SkGAP/gapaeffishbone/${gapAnalyzeId}/${fishboneConceptId}/${gapAnalyzeElementId}`, headers: authHeaderJson() })
};

const getRevisionBasicInformation = (gapAnalyzeId, gapRevisionId) => {
    return axios.get(`/api/SkGAP/gaprevisioninfo/${gapAnalyzeId}/${gapRevisionId}`, { headers: authHeaderJson() } );
};

const updateGapRevision = (gapRevisionId, formData) => {
    return axios.post(`/api/SkGAP/gaprevisionupdate/${gapRevisionId}`, formData, { headers: authHeaderJson() } )
};

const getListGapAnalyzeComments = (gapAnalyzeId, gapRevisionId, gapId, gapActionId, fromGapSection, dataserieValueId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkGAP/gapcomments/${gapAnalyzeId}/${isNullUndefinedOrEmpty(gapRevisionId) ? 0 : gapRevisionId}/${isNullUndefinedOrEmpty(gapId) ? 0 : gapId}/${isNullUndefinedOrEmpty(gapActionId) ? 0 : gapActionId}/${isNullUndefinedOrEmpty(dataserieValueId) ? 0 : dataserieValueId}/list?from_gap_section=${fromGapSection}`, { headers: authHeaderJson() } );
};

const getGapAefFishbones = (gapAnalyzeId, gap_analyze_dataserie_id = 0) => {
    return axios.get(`/api/SkGAP/gapaeffishbones/${gapAnalyzeId}/${gap_analyze_dataserie_id}/list`, { headers: authHeaderJson() } );
};

const getListGapActions = (gapAnalyzeId, elementId, gapRevisionId, gapId, dataserieValueId, gapCauseId, gapActionFromRevisionId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkGAP/gapactions/${gapAnalyzeId}/${isNullUndefinedOrEmpty(elementId) ? 0 : elementId}/${isNullUndefinedOrEmpty(gapRevisionId) ? 0 : gapRevisionId}/${isNullUndefinedOrEmpty(gapId) ? 0 : gapId}/${isNullUndefinedOrEmpty(dataserieValueId) ? 0 : dataserieValueId}/${isNullUndefinedOrEmpty(gapCauseId) ? 0 : gapCauseId}/${isNullUndefinedOrEmpty(gapActionFromRevisionId) ? 0 : gapActionFromRevisionId}/list`, { headers: authHeaderJson() } );
};

const getListLastEvents = (gapAnalyzeId, gapRevisionId, gapAnalyzeDataserieId, gapId, gapCauseId, gapActionId, iPage, iTake) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkGAP/gapanalyzelastevents/${gapAnalyzeId}/${isNullUndefinedOrEmpty(gapRevisionId) ? 0 : gapRevisionId}/${isNullUndefinedOrEmpty(gapAnalyzeDataserieId) ? 0 : gapAnalyzeDataserieId}/${isNullUndefinedOrEmpty(gapId) ? 0 : gapId}/${isNullUndefinedOrEmpty(gapCauseId) ? 0 : gapCauseId}/${isNullUndefinedOrEmpty(gapActionId) ? 0 : gapActionId}/${iPage}/${iTake}/list`, { headers: authHeaderJson() } );
};

const getActionComments = (gapAnalyzeId, gapActionId) => {
    //[##DEPRECATED##]
    return axios.get(`/api/SkGAP/gapcomments/${gapAnalyzeId}/${gapActionId}/list`, { headers: authHeaderJson() } );
};

const getListLastEventsHome = (iPage, iTake) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkHome/boardHome/lastevents/${iPage}/${iTake}`, { headers: authHeaderJson() } );
};

/*const getListLastActions = (gapAnalyzeId) => {
    let qs_gapAnalyzeId = gapAnalyzeId !== null ? `&gap_analyze_id=${gapAnalyzeId}` : '';

    return axios.get(`/api/SkGAP/gapanalyzelastactions/${gapAnalyzeId}/list?${qs_gapAnalyzeId}`, { headers: authHeaderJson() } );
};*/

const getListLastActions = (gapAnalyzeId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkGAP/gapanalyzelastactions/${gapAnalyzeId}/list`, { headers: authHeaderJson() } );
};

const saveActionsComment = (gapAnalyzeId, gapRevisionId, gapId, actionId, dataserieValueId, actionComent, fromGapSection) => {
    //[##PATH ROUTE##]
    let qs_comment = actionComent !== null ? `?comment=${encodeURIComponent(actionComent)}` : '';
    let qs_fromGapSection = fromGapSection !== null ? `&from_gap_section=gapaction` : '';

    return axios.post(`/api/SkGAP/gapcomment/${gapAnalyzeId}/${isNullUndefinedOrEmpty(gapRevisionId) ? 0 : gapRevisionId}/${isNullUndefinedOrEmpty(gapId) ? 0 : gapId}/${isNullUndefinedOrEmpty(actionId) ? 0 : actionId}/${isNullUndefinedOrEmpty(dataserieValueId) ? 0 : dataserieValueId}${qs_comment}${qs_fromGapSection}`, { headers: authHeaderJson() });
};

const getListLastActionsHome = (iPage, iTake) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkHome/boardHome/lastgapactions/${iPage}/${iTake}`, { headers: authHeaderJson() } );
};

const getListGapRevisionDocuments = (gapRevisionId) => {
    return axios.get(`/api/SkGAP/gaprevisiondocuments/${gapRevisionId}/list`, { headers: authHeaderJson() } );
};

const getPossibleGaps = (elementId, gapAnalyzeId, boardId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkGAP/gappossibles/${elementId}/${isNullUndefinedOrEmpty(gapAnalyzeId) ? 0 : gapAnalyzeId}/${isNullUndefinedOrEmpty(boardId) ? 0 : boardId}/list`, { headers: authHeaderJson() } );
};

const getGapDataseriePossiblesGaps = (elementId, gapAnalyzeId, boardId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkGAP/gapdataseriepossibles/${elementId}/${isNullUndefinedOrEmpty(gapAnalyzeId) ? 0 : gapAnalyzeId}/${isNullUndefinedOrEmpty(boardId) ? 0 : boardId}/list`, { headers: authHeaderJson() } );
};

const getListGapActionDocuments = (gapActionId) => {
    return axios.get(`/api/SkGAP/gapactiondocuments/${gapActionId}/list`, { headers: authHeaderJson() } );
};

const getDocumentsDownload = (documentListIds) => {
    return axios.post(`/api/SkGAP/gapdocumentsdownload`, documentListIds, { headers: authHeaderJson() } )
};

const addGapComment = (gapAnalyzeId, gapRevisionId, gapId, gapActionId, dataserieValueId, comment, fromGapSection) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/SkGAP/gapcomment/${gapAnalyzeId}/${isNullUndefinedOrEmpty(gapRevisionId) ? 0 : gapRevisionId}/${isNullUndefinedOrEmpty(gapId) ? 0 : gapId}/${isNullUndefinedOrEmpty(gapActionId) ? 0 : gapActionId}/${isNullUndefinedOrEmpty(dataserieValueId) ? 0 : dataserieValueId}?comment=${encodeURIComponent(comment)}&from_gap_section=${fromGapSection}`, { headers: authHeaderJson() } )
};

const addlistGap = (gapAnalyzeId, gapRevisionDataserieList) => {
    return axios.post(`/api/SkGAP/gaprevisiondataseriesadd/${gapAnalyzeId}/list`, gapRevisionDataserieList, { headers: authHeaderJson() } )
};

const addGapProcess = (elementId, gapAnalyzeId, gapProcessList) => {
    //[##PATH ROUTE##]
    return axios.put(`/api/SkGAP/gapprocess/${elementId}/${gapAnalyzeId}/list`, gapProcessList, { headers: authHeaderJson() } )
};

export {
    addGapRevision,
    getGAPById,
    getGapAnalizeByElementId,
    createGapAnalyzeProcess,
    getHomeGapStadistic,
    getElementsByGAPId,
    getListGapAnalyzeDataseriesIds,
    addFishboneToGAPBusinessElement,
    getGapRevisionsList,
    getGapRevisionPossibleGaps,
    getGapRevisionPossibleActions,
    getFishboneTemplateList,
    getGapRevisionDatareieList,
    getGapFull,
    getListGaps,
    getRevisionBasicInformation,
    updateGapRevision,
    getListGapAnalyzeComments,
    getGapAefFishbones,
    getListGapActions,
    getListLastEvents,
    getListLastEventsHome,
    getListLastActions,
    getActionComments,
    getListLastActionsHome,
    saveActionsComment,
    getListGapRevisionDocuments,
    getListGapActionDocuments,
    getDocumentsDownload,
    saveCausesByGapId,
    saveActionsByElementId,
    getGapAnalyzeMyActions,
    getListGapCausesBoard,
    addGapComment,
    getPossibleGaps,
    getGapDataseriePossiblesGaps,
    addlistGap,
    addGapProcess,
    updateActionState,
    updateGapRevisionStatus
}